module.exports = __webpack_public_path__ + "img/goodrx.8b10001.jpg";